module.exports = __webpack_public_path__ + "static/popup_SP@1x-min-27bc75986499cf70b81fe2af3fa7f02d.png";